export default __webpack_public_path__ + "static/media/info-logo.0e16510e.svg";